import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, AfterViewInit {
  @ViewChild('barChartCanvas') barChartCanvas!: ElementRef<HTMLCanvasElement>;
  private barChartContext!: CanvasRenderingContext2D;
  private chart: any;

  @Input() data: any[] = [];
  customData: any = [];
  customLabel: any = [];
  constructor() { }

  ngOnInit(): void {
    if (this.data?.length){
      this.getDataForChart(this.data);
      this.getLabelForChart(this.data);
      this.barMethod();
    }

  }
  barMethod(): void {
    Chart.register(ChartDataLabels);
    Chart.defaults.set('plugins.datalabels', {
      color: '#fff'
    });
    const context = this.barChartCanvas?.nativeElement?.getContext('2d');
    if (!context) {
      return;
    }
    this.barChartContext = context;
    this.chart = new Chart(context, {
      type: 'bar',
      data: {
        labels: this.customLabel,
        datasets: [
          {
            label: 'Workers with Access to Services',
            data: this.customData,
            backgroundColor: [
              'rgb(61, 178, 46)',
              'rgb(91, 226, 73)'
            ],
            borderColor: [
              'rgba(61, 178, 46)',
              'rgb(91, 226, 73)'
            ],
            borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          }
        },
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 20
              }
          },
        },
        indexAxis: 'x',
        barThickness: 40,
        maxBarThickness: 60
      }
    });
  }

  getLabelForChart(data: any): void {
    data?.forEach((el: any) => {
     if (el?.question_label){
       const question = el?.question_label.toLowerCase().replace(/(^|\s)\S/g, (L: any) => L.toUpperCase());
       this.customLabel.push(question);
     }
   });
 }
 getDataForChart(data: any): void {
     data?.forEach((el: any) => {
     if (el?.total_count) {
       this.customData.push(el?.total_count);
     }
   });
 }
 ngAfterViewInit(): void {
  this.barMethod();
 }
}
